/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="primary">
        <v-card-text>
          Please Wait
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorLog" width="300">
      <v-card color="#04112F">
        <v-card-title primary-title>ERROR
          <v-spacer></v-spacer>
          <v-btn icon @click="errorLog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          Please select a file to be uploaded
        </v-card-text>
      </v-card>
    </v-dialog>
    <Toolbar>
      <v-toolbar-title class="fs-16">Files</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-form method="POST" enctype="multipart/form-data" v-model="valid" ref="myForm" v-if="isUploadDisabled">
        <v-text-field type="hidden" ref="fileTextField" :value="plantId" style="display:none" name="plantId">
        </v-text-field>
        <input type="file" name="file" id="selectedFile" style="display: none" />
        <v-layout align-center justify-end row fill-height>
          <span color="gray">{{filePath ? filePath : "Browse a file"}}
          </span>
          <v-btn flat icon @click="handleFileSelect" class="elevation-0">
            <v-avatar size="32px" class="bs avatar-bg">
              <v-icon>
                attach_file
              </v-icon>
            </v-avatar>
          </v-btn>
          <v-btn flat icon class="right-space" type="file" name="file" @click.prevent="uploadDocsHandler">
            <v-avatar size="32px" class="bs avatar-bg">
              <v-icon>
                file_upload
              </v-icon>
            </v-avatar>
          </v-btn>
        </v-layout>
      </v-form>
    </Toolbar>
    <DataTable :docs="docs" :actionVisible="isUploadDisabled" :docsHeader="docsHeader"></DataTable>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import {
  Api
} from '@/services/Api'
import DataTable from '@/components/table/DataTable'

export default {
  components: {
    DataTable
  },
  data: () => ({
    dialog: false,
    errorLog: false,
    valid: null,
    docs: [],
    editedIndex: -1,
    editedItem: {
      name: ''
    },
    defaultItem: {
      name: ''
    },
    file: null,
    filePath: ''
  }),
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantInfo']),
    plantId() {
      return this.getSelectedPlantId
    },
    isUploadDisabled() {
      return this.getActivePlantInfo(['rule', 'comp_config'])["upload-docs"] &&
        this.getActivePlantInfo(['rule', 'comp_config'])["upload-docs"].options.isUpload
        ? this.getActivePlantInfo(['rule', 'comp_config'])["upload-docs"].options.isUpload
        : false;
    },
    docsHeader() {
      const header = [{
        text: 'DOCUMENTS',
        align: 'left',
        sortable: false,
        value: 'name'
      }]
      if (this.actionVisible) {
        header.push({
          text: 'ACTIONS',
          align: 'right',
          value: 'name',
          sortable: false
        })
      }
      return header
    }
  },
  watch: {
    getSelectedPlantId() {
      this.initialize()
    },
    file() {
      this.filePath = this.file.replace('C:\\fakepath\\', '')
    }
  },
  mounted() {
    this.initialize()

    if (this.isUploadDisabled) {
      document.getElementById('selectedFile').addEventListener('change', e => {
        this.file = e.target.value
      })
    }
  },
  methods: {
    handleFileSelect(e) {
      document.getElementById('selectedFile').click()
    },
    initialize() {
      Api()
        .get(`/api/v1.0/doclink/${this.getSelectedPlantId}`)
        .then(res => {
          const data = res.data.result
          if (data.length > 0 && data[0]['static_info'] != null) {
            let splitVal = data[0]['static_info'].split(',')
            let obj = []
            splitVal.forEach(r => {
              if (r == 'null') {

              } else {
                let nameLink = r.split('/')
                return (obj = [
                  ...obj,
                  {
                    name: r,
                    fileName: nameLink[nameLink.length - 1]
                  }
                ])
              }
            })
            this.docs = obj
          } else {
            this.docs = []
          }
        })
        .catch(err => console.log(err, 'Error in loading the file'))
    },
    uploadDocsHandler() {
      if (this.$refs.myForm.$el.querySelector('input[type=file]').value == '') {
        this.errorLog = true
      } else {
        this.dialog = true
        let form = this.$refs.myForm.$el
        let data = new FormData(form)
        Api().post('/api/v1.0/doclink', data)
          .then(res => {
            this.initialize()
            this.dialog = false
            this.filePath = ''
            this.$refs.myForm.$el.querySelector('input[type=file]').value = null
          })
          .catch(err => {
            this.dialog = false
            console.log(err, 'Error in uploading file')
          })
      }
    },
    deleteItem(item) {
      const index = this.docs.indexOf(item)
      let newFiles = ''
      if (this.docs.length > 0) {
        confirm('Are you sure you want to delete this item?') && this.docs.splice(index, 1)
        newFiles = this.docs.map(item => item.name).join()
      }
      if (newFiles == '') {
        newFiles = 'null'
      }
      newFiles = Buffer.from(newFiles).toString('base64')
      Api()
        .delete(`/api/v1.0/doclink/${this.getSelectedPlantId}/${newFiles}`)
        .then(res => {
          console.log(res)
        })
        .catch(err => console.log(err, 'Error in deleting the file'))
    }
  }
}
</script>

<style scoped>
.v-btn:hover::before {
  background-color: transparent;
}
</style>
